import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import LtikeCommon from "../../parts/common/LtikeCommon";
import dayjs from 'dayjs';
gsap.registerPlugin(ScrollToPlugin);

const _SESSION_KEY_MASTER_AIRPLANE_TICKET = "le_session_master_airplane_ticket";
const _LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS = "le_localstorage_airplane_search_params";
const _LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS = "le_localstorage_hotel_search_params";
const _SESSION_KEY_HOTEL_FILTER_DATA = "le_session_hotel_filter_data";

let _master_airplane_ticket = null;
let _master_airport_data = null;
let _master_airplane_price_list = null;
let _airplane_catalog = null;
let _airplane_search_params = {};
let _hotel_search_params = null;

const _BREAK_POINT = 900;
const _BASE_TIME = 0.8;
const _BASE_EASING = "power4.out";

let _isSp = false;
const _isTouch = ('ontouchstart' in window);
const _isPointer = ('PointerEvent' in window);

let _isBreakpoint = null;

const _isSafari = (navigator.userAgent.indexOf('Safari') !== -1);
const _isiOS = navigator.userAgent.match(/(iPhone|iPod)/);
const _isAndroid = navigator.userAgent.match(/Android/);
const _isAndroidChrome = (navigator.userAgent.match(/Android/) && /Chrome/.test(navigator.userAgent) && !/Version/.test(navigator.userAgent));
const _isAndroidChromeType2 = (navigator.userAgent.match(/Android/) && /Chrome/.test(navigator.userAgent));
const _isIE = (navigator.userAgent.match(/(MSIE\s)([0-9]+\.[0-9]+)/) || navigator.userAgent.match(/Trident/));
const _isEdge = navigator.userAgent.match(/Edge/);
const _isWindows = (navigator.platform.indexOf("Win") !== -1);
const _isFirefox = navigator.userAgent.match(/(firefox)/i);

let _windowSize = {w:0,h:0};

let _isYoutubeApiReady = false;
let _isSpNavOpen = false;

Number.isNaN = Number.isNaN || function(value) {
    return typeof value === "number" && value !== value;
};

/**
 * 色々な処理詰め合わせ
 */
export default class Util {
    constructor() {
        this.name = "Util";
    }

    /**
     * セッションストレージ 航空券 top.json用key
     * @example
     * //get
     * Util.SESSION_KEY_MASTER_AIRPLANE_TICKET;
     * @return {String}
     */
    static get SESSION_KEY_MASTER_AIRPLANE_TICKET(){
        return _SESSION_KEY_MASTER_AIRPLANE_TICKET;
    }

    /**
     * ローカルストレージ 航空券 検索結果保持用key
     * @example
     * //get
     * Util.LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS;
     * @return {String}
     */
    static get LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS(){
        return _LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS;
    }

    /**
     * ローカルストレージ ホテル 検索結果保持用key
     * @example
     * //get
     * Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS;
     * @return {String}
     */
    static get LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS(){
        return _LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS;
    }

    /**
     * セッションストレージ ホテル　絞り込み条件保存用key
     * @example
     * //get
     * Util.SESSION_KEY_MASTER_AIRPLANE_TICKET;
     * @return {String}
     */
    static get SESSION_KEY_HOTEL_FILTER_DATA(){
        return _SESSION_KEY_HOTEL_FILTER_DATA;
    }

    /**
     * 航空券 top.jsonのデータ格納
     * @example
     * //get
     * Util.MASTER_AIRPLANE_TICKET;
     * //set
     * Util.MASTER_AIRPLANE_TICKET = {};
     * @return {Object}
     */
    static get MASTER_AIRPLANE_TICKET(){
        return _master_airplane_ticket;
    }
    static set MASTER_AIRPLANE_TICKET(_data){
        _master_airplane_ticket = _data;
    }

    /**
     * 航空券 top.jsonの空港データ
     * @example
     * //get
     * Util.MASTER_AIRPORT_DATA;
     * //set
     * Util.MASTER_AIRPORT_DATA = {};
     * @return {Object}
     */
    static get MASTER_AIRPORT_DATA(){
        return _master_airport_data;
    }
    static set MASTER_AIRPORT_DATA(_data){
        _master_airport_data = _data;
    }

    /**
     * 航空券 top.jsonの価格データ
     * @example
     * //get
     * Util.MASTER_AIRPLANE_PRICE_LIST;
     * //set
     * Util.MASTER_AIRPLANE_PRICE_LIST = {};
     * @return {Object}
     */
    static get MASTER_AIRPLANE_PRICE_LIST(){
        return _master_airplane_price_list;
    }
    static set MASTER_AIRPLANE_PRICE_LIST(_data){
        _master_airplane_price_list = _data;
    }

    /**
     * 航空券 catalog.jsonのデータ
     * @example
     * //get
     * Util.AIRPLANE_SEARCH_PARAMS;
     * //set
     * Util.AIRPLANE_SEARCH_PARAMS = {};
     * @return {Object}
     */
    static get AIRPLANE_SEARCH_PARAMS(){
        return _airplane_search_params;
    }
    static set AIRPLANE_SEARCH_PARAMS(_data){
        _airplane_search_params = _data;
    }

    /**
     * 航空券 catalog.json 検索時のパラメータ保持
     * @example
     * //get
     * Util.AIRPLANE_CATALOG;
     * //set
     * Util.AIRPLANE_CATALOG = {};
     * @return {Object}
     */
    static get AIRPLANE_CATALOG(){
        return _airplane_catalog;
    }
    static set AIRPLANE_CATALOG(_data){
        _airplane_catalog = _data;
    }

    /**
     * ホテル　検索内容の保持
     * @example
     * //get
     * Util.HOTEL_SEARCH_PARAMS;
     * //set
     * Util.HOTEL_SEARCH_PARAMS = {};
     * @return {Object}
     */
    static get HOTEL_SEARCH_PARAMS(){
        return _hotel_search_params;
    }
    static set HOTEL_SEARCH_PARAMS(_data){
        _hotel_search_params = _data;
    }

    /**
     * カレンダーのデフォルト期間(2日)
     * @example
     * //get
     * Util.DEFAULT_PERIOD;
     * @return {Number}
     */
    static get DEFAULT_PERIOD(){
        return 2;
    }

    /**
     * ブレイクポイント
     * @example
     * //get
     * const break_point = Util.BREAK_POINT;
     * @return {Number}
     */
    static get BREAK_POINT(){
        return _BREAK_POINT;
    }

    /**
     * アニメーションベースタイム
     * @example
     * //get
     * const time = Util.BASE_TIME;
     * @return {Number}
     */
    static get BASE_TIME(){
        return _BASE_TIME;
    }

    /**
     * アニメーションベースイージング
     * @example
     * //get
     * const ease = Util.BASE_EASING;
     * @return {Number}
     */
    static get BASE_EASING(){
        return _BASE_EASING;
    }

    /**
     * スマホ判定
     * @example
     * //get
     * const flag = Util.isSp;
     * @example
     * //set
     * Util.isSp = Boolean;
     * @return {Boolean}
     */
    static get isSp(){
        return _isSp;
    }
    static set isSp(_b){
        _isSp = _b;
    }

    /**
     * ブレイクポイント判定
     * @example
     * //get
     * const flag = Util.isBreakpoint;
     * @example
     * //set
     * Util.isBreakpoint = Boolean;
     * @return {Boolean}
     */
    static get isBreakpoint(){
        return _isBreakpoint;
    }
    static set isBreakpoint(_b){
        _isBreakpoint = _b;
    }

    /**
     * ポインターイベント有効判定
     * @example
     * //get
     * const flag = Util.isPointer;
     * @return {Boolean}
     */
    static get isPointer(){
        return _isPointer;
    }

    /**
     * タッチイベント有効判定
     * @example
     * //get
     * const flag = Util.isTouch;
     * @return {Boolean}
     */
    static get isTouch(){
        return _isTouch;
    }

    /**
     * ブラウザ判定 safari
     * @example
     * //get
     * const flag = Util.isSafari;
     * @return {Boolean}
     */
    static get isSafari(){
        return _isSafari;
    }

    /**
     * ブラウザ判定 iOS
     * @example
     * //get
     * const flag = Util.isiOS;
     * @return {Boolean}
     */
    static get isiOS(){
        return _isiOS;
    }

    /**
     * ブラウザ判定 Android
     * @example
     * //get
     * const flag = Util.isAndroid;
     * @return {Boolean}
     */
    static get isAndroid(){
        return _isAndroid;
    }

    /**
     * ブラウザ判定 Android4 かつ chrome
     * @example
     * //get
     * const flag = Util.isAndroidChrome;
     * @return {Boolean}
     */
    static get isAndroidChrome(){
        return _isAndroidChrome;
    }

    /**
     * ブラウザ判定 Android かつ chrome
     * @example
     * //get
     * const flag = Util.isAndroidChromeType2;
     * @return {Boolean}
     */
    static get isAndroidChromeType2(){
        return _isAndroidChromeType2;
    }

    /**
     * ブラウザ判定 IE
     * @example
     * //get
     * const flag = Util.isIE;
     * @return {Boolean}
     */
    static get isIE(){
        return _isIE;
    }

    /**
     * ブラウザ判定 isEdge
     * @example
     * //get
     * const flag = Util.isEdge;
     * @return {Boolean}
     */
    static get isEdge(){
        return _isEdge;
    }

    /**
     * ブラウザ判定 isFirefox
     * @example
     * //get
     * const flag = Util.isFirefox;
     * @return {Boolean}
     */
    static get isFirefox(){
        return _isFirefox;
    }

    /**
     * OS判定 isWindows
     * @example
     * //get
     * const flag = Util.isWindows;
     * @return {Boolean}
     */
    static get isWindows(){
        return _isWindows;
    }

    /**
     * ウィンドウサイズ
     * @example
     * //get
     * const object = Util.windowSize;
     * @example
     * //set
     * Util.windowSize({w:width,h:height});
     * @return {Object} w:横幅 | h:縦幅
     */
    static get windowSize(){
        return _windowSize;
    }
    static set windowSize(_obj){
        _windowSize = _obj;
    }

    /**
     * youtubeApiReady 状態
     * @example
     * //get
     * const flag = Util.isYoutubeApiReady;
     * @example
     * //set
     * Util.isYoutubeApiReady = Boolean;
     * @return {Boolean}
     */
    static get isYoutubeApiReady(){
        return _isYoutubeApiReady;
    }
    static set isYoutubeApiReady(b){
        _isYoutubeApiReady = b;
    }

    /**
     * スマホナビ開閉状態
     * @example
     * //get
     * const flag = Util.isSpNavOpen;
     * @example
     * //set
     * Util.isSpNavOpen = Boolean;
     * @return {Boolean}
     */
    static get isSpNavOpen(){
        return _isSpNavOpen;
    }
    static set isSpNavOpen(b){
        _isSpNavOpen = b;
    }


    /**
     * 配列内の重複を削除
     * @param {Array} arr
     * @example
     * const arr = Util.getUniqueArr([0,1,2,0,1,2,3]);
     * arr -> [0,1,2,3];
     * @return {Array}
     */
    static getUniqueArr(arr) {
        let storage = {};
        let re = [];
        let value;
        for (let i = 0; i < arr.length; i++) {
            value = arr[i];
            if (!(value in storage)) {
                storage[value] = true;
                re.push(value);
            }
        }
        return re
    }

    /**
     * 配列をシャッフル（非破壊）
     * @example
     * const arr = [0,1,2,3,4,5,6];
     * Util.getUniqueArr(arr);
     * @param {Array} arr
     */
    static getArrayShuffle(arr) {
        let m = arr.length, t, i;
        while (m) {
            i = Math.floor(Math.random() * m--);
            t = arr[m];
            arr[m] = arr[i];
            arr[i] = t;
        }
    }

    /**
     * ウィンドウサイズを取得（inner）
     * @example
     * const object = Util.getWindowSize();
     * @return {Object} .w:横幅 .h:縦幅 .r:密度
     */
    static getWindowSize(){
        let r = (window.devicePixelRatio)? window.devicePixelRatio : 1;
        let w = Util.getWindowWidth();
        let h = window.innerHeight;
        return {w:w,h:h,r:r};
    }

    /**
     * 画面幅取得（inner）
     * @example
     * const width = Util.getWindowWidth();
     * @param isScrollWidth
     * @return {number}
     */
    static getWindowWidth(isScrollWidth = false){
        let w = window.innerWidth;
        if(isScrollWidth) w -= Util.getWindowScrollWidth();
        return w;
    }

    /**
     * ScrollTopを取得
     * @example
     * const number = Util.getScrollY();
     * @return {Number}
     */
    static getScrollY(){
        return (window.scrollY == null)? document.documentElement.scrollTop : window.scrollY;
    }

    /**
     * スクロールバーの横幅を取得
     * @example
     * const number = Util.getWindowScrollWidth();
     * @return {Number}
     */
    static getWindowScrollWidth(){
        if(!document.body) return 0;
        let scrollbarElem = document.createElement('div');
        scrollbarElem.setAttribute('style', 'visibility: hidden; position: absolute; top: 0; left: 0; width: 100vw;');
        document.body.appendChild(scrollbarElem);
        let vw = parseInt(window.getComputedStyle(scrollbarElem).width);
        scrollbarElem.style.width = '100%';
        let pc = parseInt(window.getComputedStyle(scrollbarElem).width);
        document.body.removeChild(scrollbarElem);
        return vw - pc;
    }

    /**
     * SPのパスを生成
     * @param {String} src
     * @example
     * const path = Util.getSpImagePath("./img/xxx.gif");
     * path -> "./img/sp/xxx.gif"
     * @return {String}
     */
    static getSpImagePath(src){
        let arr = src.split("/");
        arr.splice(arr.length - 1, 0, 'sp');
        return arr.join("/")
    }

    /**
     * クリック関数へ指定するとスムーススクロールが実装される
     * @example
     * $("a").on("click",Util.onClick_anchor);
     */
    static onClick_anchor(e){
        e.preventDefault();
        let h= $(e.currentTarget).attr("href");
        let t = $(h === "#" || h === "" ? 'html' : h);
        Util.runScroll(t)
    }

    /**
     * スムーススクロールを実行
     * @param {jQueryObject} _target
     * @example
     * Util.runScroll($("#content1"));
     */
    static runScroll(_target,_offsetY = 0){
        let p = _target.offset().top - _offsetY;
        gsap.to(window, {duration: 0.3, scrollTo:{y:p},ease:"power3.out"});
    }

    /**
     * スムーススクロールを実装
     * @param {jQueryObject} _target
     * @example
     * Util.setAnchor($("#main"));
     */
    static setAnchor(_target){
        let t = (_target)? _target : "body";
        $('a[href^="#"]',t).on("click",Util.onClick_anchor);
    }

    /**
     * 引数のターゲット位置へスムーススクロールを削除
     * @param {jQueryObject} _target
     * @example
     * Util.clearAnchor($("#main"));
     */
    static clearAnchor(_target){
        let t = (_target)? _target : "body";
        $('a[href^="#"]',t).off("click",Util.onClick_anchor);
    }

    /**
     * htmlにos名をclassとして挿入
     * windows => html.windows
     * mac => なし
     * @example
     * Util.setOsName();
     */
    static setOsName(){
        let name = "";
        if(navigator.platform.indexOf("Win") !== -1){
            name = "windows";
        }
        $("html").addClass(name);
    }

    /**
     * htmlにブラウザ名をclassとして挿入
     * Firefox => html.firefox
     * IE => html.ie
     * Edge => html.edge
     * Safari & Chrome => html.webkit
     * @example
     * Util.setBrowserName();
     */
    static setBrowserName(){
        let name = "";
        if(navigator.userAgent.match(/(firefox)/i)){
            name = "firefox";
        } else if(Util.isIE) {
            name = "ie";
        } else if(Util.isEdge){
            name = "edge";
        } else if(navigator.userAgent.match(/(webkit)/i)){
            name = "webkit";
        }
        $("html").addClass(name);
    }

    /**
     * 2点間から角度を取得
     * @param {Number} p1
     * @param {Number} p2
     * @example
     * const angle = Util.getAngle(100,100);
     */
    static getAngle(p1,p2){
        let angle = Math.atan2((p1.y-p2.y),(p1.x-p2.x))/(Math.PI/180);
        angle = (angle < 0)? 360 - Math.abs(angle) : angle;
        return angle;
    }

    /**
     * 角度から四方向を判定し文字列を取得
     * @param {Number} angle
     * @example
     * const direction = Util.getDirection(Util.getAngle(100,100));
     * @return {String} left or right or down or up
     */
    static getDirection(angle){
        if((angle <= 45 && angle >= 0) || (angle <= 360 && angle >= 315)){
            return 'left';
        } else if(angle >= 135 && angle <= 225){
            return 'right';
        } else if(angle > 45 && angle < 135){
            return 'down';
        } else {
            return 'up';
        }
    }

    /**
     * cssのtransformの値をObjectへ変換
     * @param {String} v
     * @example
     * const matrix = Util.getTransfromValue($(".target").css("transform"));
     * @return {Object} scale-x,scale-y,rotate-p,rotate-m,transform-x,transform-y
     */
    static getTransfromValue(v){
        let values = v.split('(')[1];
        values = values.split(')')[0];
        values = values.split(', ');
        let matrix = {
            'scale-x':values[0],
            'rotate-p':values[1],
            'rotate-m':values[2],
            'scale-y':values[3],
            'transform-x':values[4],
            'transform-y':values[5]
        };
        return matrix;
    }
    
    /**
     * urlのパラメータ取得
     * @param {String} _search デフォルトはlocation.search
     * @example
     * const params = Util.getUrlVars();
     * @return {Object}
     */
    static getUrlVars(_search){
        let search = (_search)? _search : location.search ;
        let vars = {};
        let param = search.substring(1).split('&');
        for(let i = 0; i < param.length; i++) {
            let keySearch = param[i].search(/=/);
            let key = '';
            if(keySearch !== -1) key = param[i].slice(0, keySearch);
            let val = param[i].slice(param[i].indexOf('=', 0) + 1);
            if(key !== '') vars[key] = decodeURI(val);
        }
        return vars;
    }

    /**
     * 指定範囲でのランダムのFloat生成
     * @param _min
     * @param _max
     * @return {*}
     */
    static getRandomFloat(_min,_max){
        return (Math.random() * (_max - _min)) + _min;
    }

    /**
     * 指定範囲でのランダムのInt生成
     * @param _min
     * @param _max
     * @return {*}
     */
    static getRandomInt(_min,_max){
        return Math.floor(Math.random() * (_max - _min + 1)) + _min;
    }

    /**
     * 配列からランダムで一つ取得
     * @param arr
     * @return {*}
     */
    static getRandomItem(arr){
        return arr[this.getRandomInt(0, arr.length - 1)];
    }

    /**
     * 数値をカンマ区切りに
     * @param _val
     * @return {string}
     */
    static commaPunctuation(_val){
        return Number(_val).toLocaleString();
    }


    /**
     * apiへアクセスし戻り値を取得
     * @param {Object} _params {url:} 現状はurlのみ
     * @param {Function} _success 成功時の戻りの際に実行する関数
     * @param {Function} _error 失敗時の戻りの際に実行する関数
     * @example
     * Util.apiCall({url:"top.json"},()=>{},()=>{});
     * @return {jqxhrObject}
     */
    static apiCall(_params,_success,_error){
        if(!_error) {
            _error = function(_res){
                console.log(_res);
                if(_res.statusText === "abort") {

                } else {
                    window.alert(LtikeCommon.TEXT.ERROR_API_ERROR);
                }
            }
        }
        return $.ajax({
            url:_params.url,
            type:'GET',
            dataType:'json',
            timeout:LtikeCommon.API.TIMEOUT,
            cache:false,
            success:(_res)=>{
                if(_res.errorcode){
                    let msg = "";
                    let code = "";
                    if(_res.errorMessage){
                        msg = _res.errorMessage;
                        code = _res.errorcode;
                    } else if(_res.catalog.response.error && _res.catalog.response.error.item && _res.catalog.response.error.item.errormessage){
                        msg = _res.catalog.response.error.item.errormessage;
                        code = _res.catalog.response.error.item.errorcode;
                    }
                    //window.alert(code+":"+msg);
                    console.error(code+":"+msg,_res);
                    _error(_res);
                } else {
                    _success(_res);
                }
            },
            error:_error
        });
    }

    /**
     * ローカルストレージから航空券のパラメータを復元
     */
    static setAirplaneSearchParams(){
        let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS);
        let detail = null;
        if(searchParams){
            searchParams = JSON.parse(searchParams);
            //console.log(searchParams);

            const fromData = Util.MASTER_AIRPORT_DATA[searchParams.airport.from];
            const toData = Util.MASTER_AIRPORT_DATA[searchParams.airport.to];

            const going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.going,"d");
            const back = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.back,"d");

            detail = {
                airport:{
                    from:fromData,
                    to:toData,
                },
                date:{
                    going:going,
                    back:back
                },
                passengers:searchParams.passengers,
                isOneWay:(parseInt(searchParams.methoditinerary) === 1)
            };
        }

        Util.DP_SEARCH_PARAMS = {detail:detail};
    }

    /**
     * ローカルストレージ 取得
     * @param {String} _key
     */
    static localstrageGetItem(_key){
        try{
            return (localStorage)? localStorage.getItem(_key) : null;
        } catch(e){
            return null;
        }
    }


    /**
     * ローカルストレージ　設定
     * @param {String} _key
     * @param {String} _val
     */
    static localstrageSetItem(_key,_val){
        try{
            if(localStorage) localStorage.setItem(_key,_val);
        } catch(e){
        }
    }


    /**
     * セッションストレージ 取得
     * @param {String} _key
     */
    static sessionStorageGetItem(_key){
        try{
            return (sessionStorage)? sessionStorage.getItem(_key) : null;
        } catch(e){
            return null;
        }
    }


    /**
     * セッションストレージ　設定
     * @param {String} _key
     * @param {String} _val
     */
    static sessionStorageSetItem(_key,_val){
        try{
            if(sessionStorage) sessionStorage.setItem(_key,_val);
        } catch(e){
        }
    }

    /**
     * ゼロ埋め
     * @param {Number} _n ゼロ埋めしたい数値
     * @param {Number} _digit ゼロ埋めしたい桁数
     * @example
     * const test = Util.zeroPadding(1);
     * @return {String}
     */
    static zeroPadding(_n,_digit=2){
        let zero = "";
        for(let i=0;i<_digit;i++) zero += "0";
        return ( zero + _n ).slice(_digit*-1);
    }

    /**
     * カンマ単位付き文字へ変換
     * @param {Number} _n 数値
     * @example
     * const test = Util.zeroPadding(1);
     * @return {String}
     */
    static numberToPrice(_n){
        return _n.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
    }

    /**
     * 曜日を返す
     * @param {dayjsObject} _dayjs
     * @returns {string}
     */
    static getWeek(_dayjs){
        let re = "";
        const weeks = ['日','月','火','水','木','金','土'];
        re = weeks[_dayjs.get('day')];
        return re;
    }

    /**
     * 出発地と目的地から価格のリストを返す
     * @param {String} _dCode 出発地の空港コード
     * @param {String} _aCode 目的地の空港モード
     * @returns {Array}
     */
    static getPriceList(_dCode,_aCode){
        const tmpPrice = Util.MASTER_AIRPLANE_PRICE_LIST[_dCode];
        let priceList = null;
        if(tmpPrice){
            priceList = tmpPrice[_aCode];
        } else {
            if(Util.MASTER_AIRPLANE_PRICE_LIST[_aCode]) priceList = Util.MASTER_AIRPLANE_PRICE_LIST[_aCode][_dCode];
        }
        return priceList;
    }

    /**
     * 文字列をエスケープ
     * @param string
     * @return {string}
     */
    static getEscapeHTML(string) {
        let strings = {
            '&': '&',
            '<': '<',
            '>': '>',
            '"': '"',
            "'": "'",
            '/': '/',
            '`': '`',
            '=': '='
        };
        return String(string).replace(/[&<>"'`=\/]/g, function(s) {
            return strings[s];
        });
    }

    static yieldToMain () {
        return new Promise(resolve => {
            setTimeout(resolve, 0);
        });
    }

    static checkItems(items){
        //console.log("checkItems",typeof items,items,!items,typeof items === "undefined");
        if(Array.isArray(items)) {
            return items;
        } else if(typeof items === "undefined" || !items){
            return [];
        } else {
            return [items];
        }
    }
}